<template>
  <router-view />
  <AppToast />
</template>

<script setup>
import AppToast from '@/components/AppToast.vue'
</script>
